import {apiUrl} from '../../../settings'

export const uploadApDocumentAndStatusUrl = () => {
  return apiUrl + '/api/uploadAppDocumentAndStatus'
}
